import React, { Component } from 'react';
import { Checkbox, Col, Form, Input, Row, Select } from 'antd';
import { SubTitle } from 'common-components/typography';
import { FormComponentProps } from 'antd/es/form';
import TextArea from 'antd/lib/input/TextArea';
import { GhostButton } from 'common-components/buttons';
const { Option } = Select;

interface IFundGoalDetailRowProps extends FormComponentProps {
  goal: any;
  rowIndex: number;
  onRemoveRow: (key: number) => void;
}

interface IFundGoalDetailRowState {}

class FundGoalEditDetailRow extends Component<IFundGoalDetailRowProps, IFundGoalDetailRowState> {
  render() {
    const { form, goal, rowIndex, onRemoveRow } = this.props;
    const { getFieldDecorator } = form;

    if (goal?.isDeleted) {
      return <></>;
    }

    return (
      <Row gutter={16}>
        <Col span={6}>
          <SubTitle>Goal Type</SubTitle>
          <Form.Item>
            {getFieldDecorator('type', {
              initialValue: goal.type,
            })(
              <Select style={{ width: '100%' }}>
                <Option value={'shortTerm'}>Short Term</Option>
                <Option value={'longTerm'}>Medium/Long Term</Option>
              </Select>,
            )}
          </Form.Item>
        </Col>
        <Col span={0}>
          <Form.Item>
            {getFieldDecorator('fundingNDISGoalId', { initialValue: goal.fundingNDISGoalId })(<Input />)}
          </Form.Item>
          <Form.Item>{getFieldDecorator('isDeleted', { initialValue: false })(<Checkbox />)}</Form.Item>
        </Col>
        <Col span={6}>
          <SubTitle>Goal Title</SubTitle>
          <Form.Item>{getFieldDecorator('goalTitle', { initialValue: goal.goalTitle })(<Input />)}</Form.Item>
        </Col>
        <Col span={9}>
          <SubTitle>Goal Description</SubTitle>
          <Form.Item>
            {getFieldDecorator('goalDescription', {
              initialValue: goal.goalDescription,
            })(
              <TextArea
                placeholder={'Goal Description'}
                name={goal.type + 'GoalDESC'}
                autoSize={{ minRows: 3, maxRows: 3 }}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={3}>
          <GhostButton
            icon="close"
            size="medium"
            paddingSize="medium"
            color="black"
            onClick={() => onRemoveRow(rowIndex)}
          />
        </Col>
      </Row>
    );
  }
}

export default Form.create<IFundGoalDetailRowProps>()(FundGoalEditDetailRow);
